var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneNumbers = function SvgPhoneNumbers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_numbers_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.707 1.65a.5.5 0 0 0-.719-.1l-.787.63a1.58 1.58 0 0 0-.584 1.399 9.896 9.896 0 0 0 8.805 8.805 1.58 1.58 0 0 0 1.398-.584l.63-.788a.5.5 0 0 0-.1-.719L10.4 8.9a.5.5 0 0 0-.644.054l-.655.655a1.06 1.06 0 0 1-1.088.257 6.13 6.13 0 0 1-3.876-3.877 1.06 1.06 0 0 1 .257-1.087l.655-.655A.5.5 0 0 0 5.1 3.6zM2.363.77a1.5 1.5 0 0 1 2.158.299L5.915 3.02a1.5 1.5 0 0 1-.16 1.933l-.655.655a.06.06 0 0 0-.015.064 5.13 5.13 0 0 0 3.243 3.244.06.06 0 0 0 .065-.015l.655-.655a1.5 1.5 0 0 1 1.932-.16l1.952 1.394c.7.5.837 1.485.3 2.157l-.63.788a2.58 2.58 0 0 1-2.285.953A10.895 10.895 0 0 1 .622 3.683 2.58 2.58 0 0 1 1.576 1.4z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_numbers_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneNumbers);
export default ForwardRef;